import { render, staticRenderFns } from "./LimitExceeded.vue?vue&type=template&id=40f9e8de&scoped=true&"
import script from "./LimitExceeded.vue?vue&type=script&lang=js&"
export * from "./LimitExceeded.vue?vue&type=script&lang=js&"
import style0 from "./LimitExceeded.vue?vue&type=style&index=0&id=40f9e8de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9e8de",
  null
  
)

export default component.exports